import { Item_Doc } from "shared/types/types";
import FileUploader from "../FileUploader";
import File from "../File/File";
import EmptyContent from "../EmptyContent";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "features/account";
import { FolderContext } from "features/documents";
import { useParams } from "react-router-dom";

interface DocListProps {
    garantId?: string,
    categoriePieces?: string,
    sectionsDossier?: string,
    typeGarantie?: string,
}

export default function DocList({
  categoriePieces,
  sectionsDossier,
  typeGarantie,
  garantId,
}: DocListProps){

    const { user } = useContext(UserContext);
    const type = user?.type;
    const { folder, tryAddFileToGarant, tryGetFolder, tryAddFileToFolder } = useContext(FolderContext);

    let { id } = useParams();
    const [documents, setDocuments] = useState<any[]>([]);

    useEffect(() => {
        const docs: any[] = [];
        if (typeGarantie) {
          folder?.garants.map((garant) => {
            if (garant.id.toString() === garantId) {
              garant?.documents?.map((doc: any) => {
                if (
                  doc.categoriePieces === categoriePieces
                  && doc.sectionsDossier === sectionsDossier
                  && garant.typeGarantie === typeGarantie
                ) {
                  docs.push(doc);
                }
              });
            }
          })
        } else {
          folder?.documents.map((doc) => {
            if (doc.categoriePieces === categoriePieces && doc.sectionsDossier === sectionsDossier
            ) {
              docs.push(doc)
            }
          })
        }
        setDocuments(docs);
    }, [categoriePieces, folder, sectionsDossier, typeGarantie, folder?.documents, garantId]);

    const fileUploaderProps = {
        className: "mb-0",
        title: "Ajouter",
        allowedFormats:
          "application/pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        onDelete: () => console.log("delete"),
        isList: false,
    };

    const handleUploadFile = async (
      files: any,
      fileType: string,
      ) => {
        files.map(async (file: any) => {
            try {
                if (typeGarantie) {
                  await tryAddFileToGarant(type, id, garantId, file, categoriePieces, sectionsDossier);
                } else {
                  await tryAddFileToFolder(type, id, file, fileType, categoriePieces, sectionsDossier);
                }
                // Fetch folder when add folder because reactivity doesn't work on the response addFolder
                await tryGetFolder(type, folder?.id.toString());
            } catch (error) {
                console.log(error);
            }
        });
    };

    return (
      <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
          <div
            className="d-flex gap-1 mb-2 "
            style={{ flexWrap: "wrap" }}>
              {folder?.ownerId.toString() === user?.id?.toString() && (
                <FileUploader
                  {...fileUploaderProps}
                  onChange={(files) => {
                      handleUploadFile(files, "VERBAL");
                  }}
                  isList={false}
                />
              )}
              {documents && documents?.length > 0 ? (
                documents.map((file: any, index: any) => (
                  <File
                    key={index}
                    file={file}
                    isEditable={folder?.ownerId.toString() === user?.id?.toString()}
                    garantId={garantId}
                  />
                ))
              ) : (
                <EmptyContent text="Aucun document dans ce dossier" />
              )}
          </div>
      </div>
    )
}